import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const Item = styled.div<{ $isDragging: boolean; $disabled?: boolean }>`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  border-radius: 4px;
  cursor: ${({ $disabled }) => ($disabled ? 'pointer' : 'grab')}!important;
  user-select: none;
  box-sizing: border-box;
  z-index: ${({ $isDragging }) => ($isDragging ? 2 : 1)};
  opacity: ${({ $disabled }) => ($disabled ? 0.7 : 1)};
`

export const ResizeButton = styled.div<{ $side: 'left' | 'right' }>`
  height: 100%;
  width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  background-color: ${COLORS.primaryExtraDark};
  cursor: ew-resize;
  z-index: 1;
  user-select: none;

  ${({ $side }) =>
    $side === 'left'
      ? `
        left: 0;
        border-radius: 4px 0 0 4px;
      `
      : `
        right: 0;
        border-radius: 0 4px 4px 0;
      `}
`

export const ResizeButtonLine = styled.div`
  width: 3px;
  height: 30px;
  border-radius: 2px;
  background-color: ${COLORS.white};
`
